import styled from "styled-components"

const EndTypo = styled.div`
  height: auto;
  font-family: "sub-font";
  position: relative;
  text-align: center;
  vertical-align: top;
  top: 60px;
  color: #bbb;
  font-size: 1.6rem;

  @media (max-width: 872px) {
    font-family: "English-font";
    font-size: 1.5rem;
  }
  align-items: center;
`

function ContentEnd() {
  return (
    <EndTypo>
      All content is complete. <br />
      Thank you for your visit.
    </EndTypo>
  )
}

export default ContentEnd
